import {
  Box,
  List,
  ListItem,
  Chip,
  makeStyles,
  InputAdornment,
  TextField,
  CircularProgress,
  TablePagination,
  Typography,
  Icon,
  IconButton,
  Tooltip,
  Button,
} from "@material-ui/core";
import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context";
import SearchRoundedIcon from "@material-ui/icons/SearchRounded";
import { useDebounce } from "../../hooks/useDebounce";
import { capitalizeFirstLetterArray, getHonorific } from "../../helpers";
import { Toast } from "../../components";
import CheckCircleOutlineRoundedIcon from "@material-ui/icons/CheckCircleOutlineRounded";
import SettingsBackupRestoreOutlinedIcon from "@material-ui/icons/SettingsBackupRestoreOutlined";
export default function DoctorList({
  doctors,
  loading,
  doctorsSelected,
  changeDoctorsSelected,
  page,
  limit,
  count,
  changePaginationDoctors,
  restoreDoctorsSelected,
}) {
  const { authState } = useContext(AuthContext);
  const isMasterAdmin = authState.user.role._id === "5fdb9e3db3bfce86908e440f";
  const classes = useStyles();
  const [localRegex, setLocalRegex] = useState("");
  const regexDebounced = useDebounce(localRegex, 500);
  const [toast, setToast] = useState({ open: false, message: "" });

  useEffect(() => {
    changePaginationDoctors({
      action: "QUERY",
      data: {
        query: regexDebounced,
      },
    });
  }, [regexDebounced]);
  return (
    <>
      <Toast
        open={toast.open}
        message={toast.message}
        close={() => setToast({ open: false, message: "" })}
      />
      <Box
        style={{ marginTop: 8, display: "flex", alignItems: "center", gap: 8 }}
      >
        <TextField
          style={{ flex: "1 1 90%" }}
          placeholder="nombre...rut...email"
          disabled={loading}
          value={localRegex}
          variant="outlined"
          size="small"
          onChange={(e) => setLocalRegex(e.target.value)}
          fullWidth
          className={classes.searchBar}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon />
              </InputAdornment>
            ),
          }}
        />
        {!!Object.keys(doctorsSelected || {}).length && (
          <Button
            color="primary"
            variant="outlined"
            className={classes.restore_selection}
            onClick={restoreDoctorsSelected}
          >
            <Icon style={{ display: "flex" }}>
              <SettingsBackupRestoreOutlinedIcon />
            </Icon>
            <Typography
              component={"span"}
              data-label="label"
              style={{ lineHeight: 1.1 }}
            >
              Restaurar seleccion
            </Typography>
          </Button>
        )}
      </Box>
      <Box component={"section"} className={classes.container_content}>
        {/* render view */}
        {loading || !doctors ? (
          <Box display={"flex"} justifyContent={"center"} marginTop={2}>
            <CircularProgress />
          </Box>
        ) : (
          <List className={classes.doctors_list}>
            {doctors?.map((d) => {
              const {
                _id: doctorId,
                name,
                lastName,
                specialties,
                rut,
                gender,
                type,
                email,
              } = d;
              const fullName = capitalizeFirstLetterArray(
                `${name} ${lastName}`
              );
              const fullNameWithHonorific = `${getHonorific({
                gender,
                type,
              })} ${fullName}`;
              const toAssign = !!doctorsSelected?.[doctorId];
              return (
                <ListItem
                  button
                  onClick={() => {
                    changeDoctorsSelected({
                      data: {
                        doctorId,
                        name: fullNameWithHonorific,
                        rut,
                        specialties,
                      },
                    });
                  }}
                  data-state={toAssign ? "active" : ""}
                  key={doctorId}
                  component={"li"}
                  className={classes.doctors_list_item}
                >
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      position: "relative",
                      width: "100%",
                    }}
                  >
                    <Typography
                      component={"h6"}
                      style={{ width: "90%", lineHeight: 1.2 }}
                    >
                      {fullNameWithHonorific}
                    </Typography>
                    {toAssign && (
                      <Icon
                        style={{
                          display: "flex",
                          position: "absolute",
                          top: "0",
                          right: "0",
                          width: "auto",
                          height: "auto",
                        }}
                      >
                        <CheckCircleOutlineRoundedIcon
                          fontSize="small"
                          color="secondary"
                        />
                      </Icon>
                    )}
                    <Typography variant="caption" style={{ marginBottom: 12 }}>
                      {rut}
                    </Typography>
                    <Typography variant="body2" color="textSecondary" style={{wordWrap:'break-word'}}>
                      {email}
                    </Typography>

                    <Box style={{ display: "flex", flexWrap: "wrap" }}>
                      {specialties.map((s) => (
                        <Chip
                          size="small"
                          variant="outlined"
                          style={{ fontSize: "0.8rem" }}
                          label={s.name}
                          key={`${doctorId}-${s._id}`}
                        />
                      ))}
                    </Box>
                  </Box>
                </ListItem>
              );
            })}
          </List>
        )}
        {doctors?.length === 0 && !loading && (
          <Box
            style={{
              display: "flex",
              padding: "12px 8px",
              backgroundColor: "#ffa50038",
            }}
          >
            <Typography>No hay coincidencias para su búsqueda.</Typography>
          </Box>
        )}
      </Box>
      <Box display="flex" justifyContent={"end"}>
        <TablePagination
          labelRowsPerPage="Cant."
          component="div"
          count={count || 0}
          onRowsPerPageChange={(e) => {
            changePaginationDoctors({
              action: "LIMIT",
              data: { limit: e.target.value },
            });
          }}
          onPageChange={(e, page) =>
            changePaginationDoctors({
              action: "PAGE",
              data: { page: page + 1 },
            })
          }
          page={page - 1}
          rowsPerPage={limit}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </Box>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  container_content: {
    flex: 1,
    maxHeight: "46vh",
    overflowY: "auto",
  },
  searchBar: {
    marginTop: 8,
    marginBottom: 8,
    "& fieldset": {
      borderRadius: 24,
    },
  },
  doctors_list: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))",
    gap: theme.spacing(2),
    padding: theme.spacing(1),
  },
  doctors_list_item: {
    borderRadius: theme.spacing(2),
    paddingBlock: theme.spacing(2.5),
    backgroundColor: `hsl(from ${theme.palette.primary.light} h s calc(l + 55))`,
    boxShadow: theme.shadows[1],
    '&[data-state="active"]': {
      outline: `2px solid ${theme.palette.secondary.main}`,
      outlineOffset: "-2px",
    },
  },
  restore_selection: {
    padding: 4,
    height: 35,
    display: "flex",
    alignItems: "center",
    width: "auto",
    borderRadius: 24,
    [theme.breakpoints.down("sm")]: {
      "& span[data-label='label']": {
        display: "none",
      },
    },
  },
}));
